/**
 * Application-wide constants.
 * Update APP_NAME here to reflect the project name across the entire app.
 */
export const APP_NAME = "Cardamom Kitchen";
